export default {
    computed: {
        havePermissionToCreate() {
          return this.$route.meta.roles[0].create.includes(
            this.$auth.user().roles[0].name
          )
        },
        havePermissionToRemove() {
          return this.$route.meta.roles[0].remove.includes(
            this.$auth.user().roles[0].name
          )
        },
        havePermissionToEdit() {
          return this.$route.meta.roles[0].edit.includes(
            this.$auth.user().roles[0].name
          )
        },
        userPermission() {
            return this.$route.meta.roles.includes(this.$auth.user().roles[0].name)
        }
    }    
}